import * as firebase from 'firebase/app'
import 'firebase/auth'

export const apiSignIn = async (email, password) => {
  return new Promise((resolve, reject) => {
    try
    {
      firebase.auth().signInWithEmailAndPassword(email, password).then(
        (response) => {
          resolve({ code: 1, message: response })
        },
        error => {
          resolve({ code: 0, message: error })
        }
      )
    }
    catch (e)
    {
      resolve({ code: 0, message: e })
    }
  })
}

export const apiRecoveryPassword = async email => {
  return new Promise((resolve, reject) => {
    try
    {
      firebase.auth().sendPasswordResetEmail(email).then(response => {
        resolve({ code: 1, message: response })
      }).catch((error) => {
        resolve({ code: 0, message: error })
      })
    }
    catch (e)
    {
      resolve({ code: 0, message: e })
    }
  })
}
